import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Addons = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0287 2.89567C11.6328 2.56009 12.3672 2.56009 12.9713 2.89567L16.4713 4.84011C17.1062 5.19285 17.5 5.86209 17.5 6.58843V10.4116L20.9713 12.3401C21.6062 12.6929 22 13.3621 22 14.0884V17.9116C22 18.638 21.6062 19.3072 20.9713 19.6599L17.4713 21.6044C16.8672 21.94 16.1328 21.94 15.5287 21.6044L12.0287 19.6599C12.0191 19.6546 12.0095 19.6492 12 19.6437C11.9905 19.6492 11.9809 19.6546 11.9713 19.6599L8.47129 21.6044C7.86724 21.94 7.13276 21.94 6.52871 21.6044L3.02871 19.6599C2.39378 19.3072 2 18.638 2 17.9116V14.0884C2 13.3621 2.39378 12.6929 3.02871 12.3401L6.5 10.4116V6.58843C6.5 5.86209 6.89378 5.19285 7.52871 4.84011L11.0287 2.89567ZM8.5 10.4116L12 12.3561L15.5 10.4116V6.58843L12 4.64398L8.5 6.58843V10.4116ZM13 14.0884V17.9116L16.5 19.8561L20 17.9116V14.0884L16.5 12.144L13 14.0884ZM7.5 12.144L4 14.0884V17.9116L7.5 19.8561L11 17.9116V14.0884L7.5 12.144Z"
      fill="currentColor"
    />
  </Icon>
));

export default Addons;
